import { render, staticRenderFns } from "./TimeStudiesTab.vue?vue&type=template&id=9dbb4406&scoped=true"
import script from "./TimeStudiesTab.vue?vue&type=script&lang=js"
export * from "./TimeStudiesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbb4406",
  null
  
)

export default component.exports